import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { useAuth } from './lib/auth';

// Antes de pintar nada se revalida la sesión contra Supabase: el perfil
// guardado en localStorage no prueba que la sesión siga viva, y sin esto
// la app arrancaría mostrando como autenticado a alguien cuyo token ya
// ha caducado.
useAuth.getState().restoreSession().finally(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
